export const otherProductClaimFileIdentifiers = [
  {
    name: 'Apólice contratada',
    key: 'POLICY_CONTRACTED',
    required: false
  },
  {
    name: 'RG ou CPF do locatário',
    key: 'TENANT_DOCUMENT',
    required: false
  },
  {
    name: 'Comprovante de Endereço',
    key: 'ADDRESS_PROOF',
    required: false
  },
  {
    name: 'Outros',
    key: 'OTHER',
    required: false
  }
];
